import { Text } from "@quintype/arrow";
import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { array, element, string } from "prop-types";
import { connect } from "react-redux";
import ErrorMessage from "../../error-message";
import { LoginPaymentBase } from "../paywall-not-logged-user/login-payment";
import './paywall-accesstype-login.m.css';

const LoginPaywallBase = ({ element, text, data, loginpaywall }) => {

  const [isTrue, setIsTrue] = useState(false);
  const onBtnClick = () => setIsTrue(true);
  var backgroundColor = (loginpaywall.length >= 1 && loginpaywall[0].data.color !== "#FFFFFF") ? loginpaywall[0].data.color : "#FFFFFF";
  var paywallTitle = loginpaywall.length >= 2 ? loginpaywall[1].title : "Tämä ei ole maksumuuri";
  var buttonColor = "#54C2F0";
  const texts = loginpaywall.find(item => item.title === "Tekstit");
  const buttons = loginpaywall.find(item => item.title === "Napit");
  const loginButton = buttons && buttons.children && buttons.children.filter(child => child["item-type"] === "placeholder")[0];
  const otherButtons = buttons && buttons.children && buttons.children.filter(child => child["item-type"] !== "placeholder");
  const [tuloUrl, setTuloUrl] = useState();
  //from Bolds Login Paywall go through all children of element which title is Tekstit.
  //If there is a child which title is Pallurat, then create an unordered list from it's children's titles.
  const textItems = (texts && texts.children.length > 0) ? texts.children.map(item => {
    if (item.title === "Lista") {
      const palluratChildren = item.children.map(child => <li key={child.id} styleName={child.data ? (child.data["icon-code"] && child.data["icon-code"] === "lista-otsikko") ? child.data["icon-code"] : "" : ""}>{child.title}</li>);
      return (
        <ul styleName="login-paywall-bullets">{palluratChildren}</ul>
      );
    } else {
      return <p key={item.id} styleName="para">{item.title}</p>;
    }
  }) : <p styleName="para">Voit lukea jutun maksutta luomalla tilin ja kirjautumalla sisään.</p>;

  //Search additional link from json, in icon code is placed "additional-link" if there is any.
  const additionalLink = loginpaywall
    .filter((item) => item.data && item.data["icon-code"] === "additional-link");

  useEffect(() => {
    if (typeof window === 'undefined') { }
    else {
      const storyUrl = window.location.href;
      if (window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("qtstage") > -1) {
        setTuloUrl(`https://imediat.payway-portal.stage.adeprimo.se/loginregistration?continue=${storyUrl}`)
      } else {
        setTuloUrl(`https://imediat.portal.worldoftulo.com/loginregistration?continue=${storyUrl}&accountOrigin=KI`)
      }
    }
  }, []);

  return (
    <div>
      {!isTrue ? (
        <div styleName="upper-wrapper" className="upper-wrapper login-paywall">

          <div styleName="upper-para-wrapper" className="upper-para-wrapper">
            <Text element={element} render={text} />
          </div>

          <div styleName="wrapper" style={{ backgroundColor: (backgroundColor ? backgroundColor : '#FFFFFF') }} className="wrapper">

            <div>
              <h2 styleName="title" className="title">
                {paywallTitle}
              </h2>
            </div>

            {textItems}
            <ErrorMessage />
            {<div styleName="buttons" className="login-buttons">
              {buttons && buttons.children.length > 0 &&
                otherButtons && otherButtons.map((button) => {
                  return (<a className="create-account-button-login-paywall" styleName="luo-tili-btn" style={{ '--luo-tili-btn-color': (button.data.color !== "#FFFFFF") ? button.data.color : buttonColor }} href={`${tuloUrl}`}>{button.title}</a>)
                })}
              {(buttons && buttons.children.length > 1 && loginButton) ?
                <a key="login" className="login-button-login-paywall" onClick={() => onBtnClick()} style={{ '--kirjaudu-btn-color': ((loginButton.data.color !== "#FFFFFF") ? loginButton.data.color : buttonColor) }} styleName="kirjaudu-btn">
                  {loginButton.title}
                </a>
                :
                <a className="login-button-login-paywall" onClick={() => onBtnClick()} style={{ '--kirjaudu-btn-color': buttonColor }} styleName="kirjaudu-btn">
                  Kirjaudu sisään
                </a>}
            </div>}

            {(additionalLink.length > 0) &&
              <div styleName="additional-link">

                <a
                  key={additionalLink[0].id}
                  style={{ '--additional-link-color': (additionalLink[0].data.color != "#ffffff") ? additionalLink[0].data.color : '#1297ce' }}
                  href={additionalLink[0].completeUrl}
                  className="additional-link-login-paywall">
                  {additionalLink[0].title}
                </a>
              </div>
            }
          </div>

        </div>
      ) : (
        <div>

          <div styleName="upper-para-wrapper" className="upper-para-wrapper">
            <Text element={element} render={text} />
          </div>

          <LoginPaymentBase />

        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    data: get(state, ["qt", "data"], []),
    loginpaywall: get(state, ["qt", "data", "navigationMenu", "loginpaywall"], [])
  };
}

LoginPaywallBase.propTypes = {
  data: array,
  loginpaywall: array
};

const LoginPaywallComponent = connect(mapStateToProps, () => ({}))(LoginPaywallBase);
export default LoginPaywallComponent;
